export const getSearchUrl = (name: string) => `/search?query=${encodeURIComponent(name)}`;
